import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    current: {},
    currentLoading: false,
    members: [],
    membersLoading: false,
    membersAll: [],
    membersAllLoading: false,

    currentMember: {},
    currentMemberLoading: false,
    users: [],
    usersLoading: false,
    membersEnteredIndividualEvents: [],
    membersEnteredIndividualEventsLoading: false,
    regions: [
      "Northern Region",
      "Southern Region",
      "Eastern Region",
      "Central Region",
      "Other"
    ],
    areas: [
      "Northern",
      "Coromandel",
      "Bay of Plenty",
      "Gisborne/Tairawhiti",
      "Taranaki",
      "Hawkes Bay",
      "Capital Coast",
      "Canterbury",
      "Otago/Southland",
      "Other"
    ],

    nfcListForMember: [],
    nfcListForMemberLoading: false
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
    setMembers(state, payload) {
      state.members = payload;
    },
    setMembersLoading(state, payload) {
      state.membersLoading = payload;
    },
    setMembersAll(state, payload) {
      state.membersAll = payload;
    },
    setMembersAllLoading(state, payload) {
      state.membersAllLoading = payload;
    },
    setCurrentMember(state, payload) {
      state.currentMember = payload;
    },
    setCurrentMemberLoading(state, payload) {
      state.currentMemberLoading = payload;
    },
    setUsers(state, payload) {
      state.users = payload;
    },
    setUsersLoading(state, payload) {
      state.usersLoading = payload;
    },
    setMembersEnteredIndividualEvents(state, payload) {
      state.membersEnteredIndividualEvents = payload;
    },
    setMembersEnteredIndividualEventsLoading(state, payload) {
      state.membersEnteredIndividualEventsLoading = payload;
    },
    setAreas(state, payload) { },
    setNfcListForMember(state, payload) {
      state.nfcListForMember = payload;
    },
    setNfcListForMemberLoading(state, payload) {
      state.nfcListForMemberLoading = payload;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("associations");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setCurrentLoading", true);
      let response = await api.get("associations/byID", { params: { id: id } });
      commit(
        "setCurrent",
        response.data.length > 1 ? response.data : response.data[0]
      );
      commit("setCurrentLoading", false);
    },
    async memberLoadByID({ commit }, id) {
      commit("setCurrentMemberLoading", true);
      let response = await api.get("associations/members/byID", {
        params: { id: id }
      });
      commit("setCurrentMember", response.data[0]);
      commit("setCurrentMemberLoading", false);
    },
    async memberNFCTagsLoadByID({ commit }, id) {
      commit("setNfcListForMemberLoading", true);
      let response = await api.get("associations/members/NFCTags/byMemberID", {
        params: { id: id }
      });
      commit("setNfcListForMember", response.data);
      commit("setNfcListForMemberLoading", false);
    },
    async loadMembers({ commit }) {
      commit("setMembersAllLoading", true);
      let response = await api.get("associationsMembers");
      commit("setMembersAll", response.data);
      commit("setMembersAllLoading", false);
    },
    async loadMembersForAssociation({ commit }, payload) {
      commit("setMembersLoading", true);
      let response = await api.get("associations/members", {
        params: payload
      });
      commit("setMembers", response.data);
      commit("setMembersLoading", false);
    },
    async loadMembersEnteredIndividualEvents({ commit }, payload) {
      commit("setMembersEnteredIndividualEventsLoading", true);
      let response = await api.get(
        "associations/membersEnteredIndividualEvents",
        {
          params: payload
        }
      );
      commit("setMembersEnteredIndividualEvents", response.data);
      commit("setMembersEnteredIndividualEventsLoading", false);
    },
    async loadUsers({ commit }, id) {
      commit("setUsersLoading", true);
      let response = await api.get("associations/users", {
        params: { id: id }
      });
      commit("setUsers", response.data);
      commit("setUsersLoading", false);
    },
    async addUser({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("associations/addUser", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("associations", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`associations`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async delete({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`associations/delete`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async addMember({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`associations/members`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadMembersForAssociation", { id: payload.associations_id });
      return returnData;
    },
    async saveMember({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`associations/members`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadMembersForAssociation", { id: payload.associations_id });
      return returnData;
    },
    async removeMember({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`associations/members/remove`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadMembersForAssociation", { id: payload.associations_id });
      return returnData;
    },
    async loadMemberViaNFC({ dispatch }, payload) {
      let response = await api.get(`associations/members/byNFC`, {
        params: payload
      });

      return response.data;
    },
    async addNFCToMember({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`associations/members/NFCTags`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      if (!payload.skipLoading) {
        dispatch("loadMembersForAssociation", { id: payload.associations_id });
      }

      return returnData;
    },
    async removeNFC({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`associations/members/NFCTags/delete`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    crm(state) {
      return state.list.filter(a => a.oa_id != "" && a.oa_id != null);
    },
    nonCrm(state) {
      return state.list.filter(a => a.oa_id == "" || a.oa_id == null);
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
    members(state) {
      return state.members;
    },
    membersLoading(state) {
      return state.membersLoading;
    },
    membersAll(state) {
      return state.membersAll;
    },
    membersAllLoading(state) {
      return state.membersAllLoading;
    },
    currentMember(state) {
      return state.currentMember;
    },
    currentMemberLoading(state) {
      return state.currentMemberLoading;
    },
    users(state) {
      return state.users;
    },
    usersLoading(state) {
      return state.usersLoading;
    },
    membersEnteredIndividualEvents(state) {
      return state.membersEnteredIndividualEvents;
    },
    membersEnteredIndividualEventsLoading(state) {
      return state.membersEnteredIndividualEventsLoading;
    },
    regions(state) {
      return state.regions;
    },
    areas(state) {
      return state.areas;
    },
    nfcListForMember(state) {
      return state.nfcListForMember
    },
    nfcListForMemberLoading(state) {
      return state.nfcListForMemberLoading
    },
    membersKeyed(state) {
      let reference = {};
      state.members.forEach(m => {
        reference[m.id] = m;
      });
      return reference;
    }
  }
};
